"use client";
import React, { useEffect, useState } from "react";
import { appConnection } from "./appConnectionContent";
import Link from "next/link";
import { useNotification } from "@/app/hooks/useNotification";

const LocationConnectionApp = () => {
  const [origin, setOrigin] = useState<{ lat: number; lng: number } | null>(
    null
  );
  const { openNotification } = useNotification();
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          setOrigin({
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          });
        },
        (err) => {
          openNotification({
            type: "error",
            message: "خطا در گرفتن موقعیت",
          });
          setOrigin(null);
        }
      );
    }
  }, []);

  const destination = { lat: 35.771602, lng: 51.365406 };

  const generateUrl = (type: string) => {
    switch (type) {
      case "google":
        return `https://www.google.com/maps/dir/?api=1&destination=${destination.lat},${destination.lng}`;
      case "waze":
        return `https://waze.com/ul?ll=${destination.lat},${destination.lng}&navigate=yes`;
      case "balad":
        return origin
          ? `https://balad.ir/directions/driving?destination=51.36533055379226%2C35.77149062914374`
          : `https://balad.ir/directions/driving?destination=51.36533055379226%2C35.77149062914374`;
      case "neshan":
        return origin
          ? `https://neshan.org/maps/routing/car/destination/35.771459,51.365385#c35.772-51.366-17z-0p`
          : `https://neshan.org/maps/routing/car/destination/35.771459,51.365385#c35.772-51.366-17z-0p`;
      default:
        return "#";
    }
  };
  return (
    <div className="flex flex-wrap w-full gap-5 md:gap-4 justify-center">
      {appConnection.map((app) => {
        const Icon = app.icon;
        const url = generateUrl(app.type);

        return (
          <Link
            href={url}
            key={app.id}
            target="_blank"
            className="cursor-pointer w-full xs:w-[calc((100%/2)-0.75rem)] md:w-[23%] md:max-w-[13rem] flex gap-2 items-center justify-center h-12 !bg-regal-blue-light rounded-md"
          >
            <div
              key={app.id}
              className="flex gap-3 items-center w-40 md:w-full justify-start md:justify-center"
            >
              <div className="w-6 h-6 flex-shrink-0">
                <Icon />
              </div>
              <span className="text-base text-primary font-semibold">
                {app.title}
              </span>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default LocationConnectionApp;
